import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'
import AuthCallback from '../views/AuthCallback.vue'
import TaskDemoView from '../views/TaskDemoView.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/auth/callback',
    name: 'AuthCallback',
    component: AuthCallback,
  },
  {
    path: '/items',
    name: 'ItemListView',
    component: () => import('../views/ItemListView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/items/:id',
    name: 'ItemDetailView',
    component: () => import('../views/ItemDetailView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/common/stazioni',
    name: 'CommonStationsView',
    component: () => import('../views/CommonStationsView.vue'),
  },
  {
    path: '/common/stazioni/esplora',
    name: 'CommonStationsExplorerView',
    component: () => import('../views/CommonStationsExplorerView.vue'),
  },
  {
    path: '/common/stazioni/:idstazione',
    name: 'CommonStationDetailView',
    component: () => import('../views/CommonStationDetailView.vue'),
    props: true,
  },
  {
    path: '/distribuzione/richieste',
    name: 'DistribuzioneRichiesteView',
    component: () => import('../views/DistribuzioneRichiesteView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/distribuzione/richieste/nuova',
    name: 'DistribuzioneRichiestaWizardView',
    component: () => import('../views/DistribuzioneRichiestaWizardView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/distribuzione/richieste/:id/modifica',
    name: 'DistribuzioneRichiestaWizardEditView',
    component: () => import('../views/DistribuzioneRichiestaWizardView.vue'),
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: '/distribuzione/admin/misura-aggregazioni',
    name: 'DistribuzioneMisuraAggregazioniView',
    component: () => import('../views/DistribuzioneMisuraAggregazioniView.vue'),
    meta: { requiresAuth: true, requiresRole: 'reg_admin' },
  },
  {
    path: '/distribuzione/admin/limiti-utente',
    name: 'DistribuzioneLimitiUtenteView',
    component: () => import('../views/DistribuzioneLimitiUtenteView.vue'),
    meta: { requiresAuth: true, requiresRole: 'reg_admin' },
  },
  {
    path: '/distribuzione/admin/prodotti',
    name: 'DistribuzioneProdottiView',
    component: () => import('../views/DistribuzioneProdottiView.vue'),
    meta: { requiresAuth: true, requiresRole: 'reg_admin' },
  },
  {
    path: '/distribuzione/admin/prodotti/:codProdotto',
    name: 'DistribuzioneProdottoDetailView',
    component: () => import('../views/DistribuzioneProdottoDetailView.vue'),
    meta: { requiresAuth: true, requiresRole: 'reg_admin' },
    props: true,
  },
  {
    path: '/distribuzione/admin/reti',
    name: 'DistribuzioneRetiView',
    component: () => import('../views/DistribuzioneRetiView.vue'),
    meta: { requiresAuth: true, requiresRole: 'reg_admin' },
  },
  {
    path: '/distribuzione/admin/reti/:idrete',
    name: 'DistribuzioneReteDetailView',
    component: () => import('../views/DistribuzioneReteDetailView.vue'),
    meta: { requiresAuth: true, requiresRole: 'reg_admin' },
    props: true,
  },
  {
    path: '/consistenza/stazioni',
    name: 'ConsistenzaStazioniView',
    component: () => import('../views/ConsistenzaStazioniView.vue'),
    meta: { requiresAuth: true, requiresRole: 'reg_admin' },
  },
  {
    path: '/consistenza/stazioni/:tabella',
    name: 'ConsistenzaStazioneDetailView',
    component: () => import('../views/ConsistenzaStazioneDetailView.vue'),
    meta: { requiresAuth: true, requiresRole: 'reg_admin' },
    props: true,
  },
  {
    path: '/consistenza/aggregazioni',
    name: 'ConsistenzaAggregazioniView',
    component: () => import('../views/ConsistenzaAggregazioniView.vue'),
    meta: { requiresAuth: true, requiresRole: 'reg_admin' },
  },
  {
    path: '/consistenza/aggregazioni/:idaggregazione',
    name: 'ConsistenzaAggregazioneDetailView',
    component: () => import('../views/ConsistenzaAggregazioneDetailView.vue'),
    meta: { requiresAuth: true, requiresRole: 'reg_admin' },
    props: true,
  },
  {
    path: '/profile',
    name: 'ProfileView',
    component: () => import('../views/ProfileView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/tasks/demo',
    name: 'TaskDemoView',
    component: TaskDemoView,
    meta: { requiresAuth: true },
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

// Auth guard
router.beforeEach((to) => {
  if (!to.meta.requiresAuth) return true

  const user = JSON.parse(localStorage.getItem('user') || 'null')
  const isAuthenticated = !!(user && user.uid && user.uid !== 0)

  if (!isAuthenticated) {
    return { name: 'Home' }
  }

  if (to.meta.requiresRole && !(user.roles || []).includes(to.meta.requiresRole)) {
    return { name: 'Home' }
  }

  return true
})

export default router
